import { DateRangeProps, SetDateRangeType } from "../../../operations";

export interface CalendarRangeProps {
  show?: boolean;
  className?: string;
  dateRange: DateRangeProps;
  setDateRange: SetDateRangeType;
  error?: string;
  disabled?: boolean;
}

export const formatDay = (day: string): string => {
  const daySplit: string[] = day.split("/");
  return daySplit[0].length === 1
    ? `0${daySplit[0]}/${daySplit[1]}/${daySplit[2]}`
    : day;
};
